"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoEnrollRules = void 0;
const sdk_1 = require("../sdk");
var AutoEnrollRules;
(function (AutoEnrollRules) {
    AutoEnrollRules.list = (options) => {
        const url = '/auto-enroll-rules';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    AutoEnrollRules.create = (data) => {
        const url = '/auto-enroll-rules';
        return sdk_1.SDK.axios.post(url, data);
    };
    AutoEnrollRules.get = (autoEnrollRuleId) => {
        const url = `/auto-enroll-rules/${autoEnrollRuleId}`;
        return sdk_1.SDK.axios.get(url);
    };
    AutoEnrollRules.update = (autoEnrollRuleId, data) => {
        const url = `/auto-enroll-rules/${autoEnrollRuleId}`;
        return sdk_1.SDK.axios.put(url, data);
    };
    AutoEnrollRules.remove = (config) => {
        const url = `/auto-enroll-rules`;
        return sdk_1.SDK.axios.delete(url, config);
    };
})(AutoEnrollRules = exports.AutoEnrollRules || (exports.AutoEnrollRules = {}));
//# sourceMappingURL=auto-enroll-rules.js.map